import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Intensity, IntensitiesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class IntensitiesDataService {

  private uri: string = `${environment.apiUrl}intensities`;
  private cacheKey: string = 'intensities.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getIntensity(id: number): Observable<Intensity|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getIntensities(parameters: {[param: string]: string | string[]}): Observable<IntensitiesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addIntensity(data: Intensity): Observable<Intensity|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addIntensities(data: Intensity[]): Observable<Intensity[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateIntensity(data: Intensity): Observable<Intensity|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateIntensities(data: Intensity[]): Observable<Intensity[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchIntensity(data: Intensity): Observable<Intensity|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchIntensities(data: Intensity[]): Observable<Intensity[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteIntensity(data: Intensity): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteIntensities(data: Intensity[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((intensity) => {
      ids.push(intensity.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
